import { useState, useEffect, useContext } from 'react';

import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { PROJECT_IMG } from '../../constants';
import { Button } from '../../styles/commonStyles';
import { BannerblurBox } from '../../styles/layOutStyles';

import { LayoutContext } from '../../context/layoutContext';
import { GlobalContext } from '../../context/globalContext';

const BannerItem = ({ data }) => {
  const history = useHistory();
  const { matchese } = useContext(LayoutContext);
  const { theme } = useContext(GlobalContext);

  const [bannerType, setBannerType] = useState('program');

  useEffect(() => {
    if (data?.id) {
      if (data?.linkProgram) {
        setBannerType('program');
      } else {
        setBannerType('url');
      }
    }
  }, [data]);

  const goProgram = tab => {
    if (!data?.linkProgram?.id) return;

    history.push(process.env.PUBLIC_URL + `/vod-detail?id=${data?.linkProgram?.id}&tab=${tab}`);
  };

  const goUrl = url => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <section
      className={`slider-height-6 swiper-slide bg-img`}
      style={{
        backgroundImage: `url(${
          matchese
            ? data?.mobileImg instanceof Array
              ? data?.mobileImg[0].url
              : data?.mobileImg?.url
            : data?.img instanceof Array
            ? data?.img[0]?.url
            : data?.img?.url
        })`,
        display: 'flex',
        alignItems: 'flex-end',
        objectFit: 'cover',
        position: 'relative',
      }}
    >
      {matchese && (
        <div
          className='mobileGoprogramArea'
          onClick={bannerType === 'program' ? () => goProgram(-1) : () => goUrl(data?.link)}
          style={{ width: '100%', position: 'absolute', top: '20%', height: '40%', zIndex: '500' }}
        ></div>
      )}
      <BannerblurBox>
        <div className='slider-content-5'>
          {matchese ? (
            <>
              <h3>{data?.title ? data?.title : ''}</h3>
              <h1>{data?.subTitle ? data?.subTitle : ''}</h1>
              {bannerType === 'program' && (
                <p>{`
                 ${data?.linkProgram?.timeInfoCycle ? data?.linkProgram?.timeInfoCycle : ''} 
                 ${data?.linkProgram?.timeInfoDay ? data?.linkProgram?.timeInfoDay : ''} 
                 ${data?.linkProgram?.startTime ? data?.linkProgram?.startTime : ''}
                 `}</p>
              )}
            </>
          ) : (
            <>
              <h3>{data?.title ? data?.title : ''}</h3>
              <h1>{data?.subTitle ? data?.subTitle : ''}</h1>
              <span>{data?.desc ? data?.desc : ''}</span>
              {bannerType === 'program' && (
                <p>{`
                ${data?.linkProgram?.timeInfoCycle ? data?.linkProgram?.timeInfoCycle : ''} 
                ${data?.linkProgram?.timeInfoDay ? data?.linkProgram?.timeInfoDay : ''} 
                ${data?.linkProgram?.startTime ? data?.linkProgram?.startTime : ''}
                `}</p>
              )}

              <div style={{ display: 'flex', marginTop: '15px' }}>
                {bannerType === 'program' ? (
                  <>
                    <Button bannerItem={true} boxShadow={true} onClick={() => goProgram(-1)}>
                      프로그램
                    </Button>
                    <Button backgroundColor='#2f4693' onClick={() => goProgram(1)} boxShadow={true}>
                      방송보기
                    </Button>
                  </>
                ) : (
                  <>
                    <Button backgroundColor='#2f4693' onClick={() => goUrl(data?.link)} boxShadow={true}>
                      바로가기
                    </Button>
                  </>
                )}
              </div>
            </>
          )}
        </div>

        <div className='banner-item-effect'>
          <img src={`${PROJECT_IMG}/${theme === 'dark' ? 'banner_dark_effect.png' : 'banner_light_effect.png'}`} />
        </div>
      </BannerblurBox>
    </section>
  );
};

BannerItem.propTypes = {
  data: PropTypes.object,
};

export default BannerItem;
